document.addEventListener("DOMContentLoaded", () => {
  const ACTIVE_CLASS = 'active';
  const ALGOLIA_SEARCH_TRIGGER_SELECTOR = '.aa-DetachedSearchButton';
  const mobileNavigationSearch = document.querySelector('.mobile-search-icon');
  const mobileSearchBar = document.querySelector('.mobile-search-bar');
  let searchTrigger = document.querySelector(ALGOLIA_SEARCH_TRIGGER_SELECTOR);


  if (window.innerWidth <= 979) {
    mobileNavigationSearch?.addEventListener('click', function(e) {
      searchTrigger = searchTrigger || document.querySelector(ALGOLIA_SEARCH_TRIGGER_SELECTOR);
      if (searchTrigger) {
        searchTrigger.click();
      } else {
        mobileSearchBar.classList.toggle(ACTIVE_CLASS);
      }
    });
  }
});

function debouncePromise(fn, time) {
  let timerId = undefined;

  return function debounced(...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    return new Promise((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time);
    });
  };
}

const debounced = debouncePromise((items) => Promise.resolve(items), 1500);
document.addEventListener('algolia.autocomplete.afterInit', () => {

  const target = document.querySelector('body');
  const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if ( mutation?.addedNodes?.length > 0 && mutation?.addedNodes?.[0]?.className === 'aa-Panel' ) {
          document.documentElement.style.overflow = 'hidden';
          document.body.classList.add('body-dark-overlay');
        } else if (mutation?.removedNodes?.length > 0 && mutation?.removedNodes?.[0]?.className === 'aa-Panel') {
          document.documentElement.style.overflow = 'auto';
          document.body.classList.remove('body-dark-overlay');
        }
      });
  });
  const config = { childList: true }
  observer.observe(target, config);

  let { getSources } = window.algoliaShopify.productsPlugin;
  const newFunc = ({ query, setContext }) => {
    try {
      const returnValue = getSources.call(this, { query, setContext });
      /* work after the function is called */
      return returnValue;
    }
    catch (e) {
      /* work in case there is an error */
      throw e;
    }
  }
  if (getSources) {
      window.algoliaShopify.productsPlugin.getSources = ({ query, setContext }) => {
        return debounced(newFunc({ query, setContext }));
      }
  }
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    const { refinementList, searchBox } = window.algoliaShopify.externals.widgets;

    const vendorWidget = refinementList({
      container: '#brand',
      attribute: 'vendor',
      limit: 10,
      showMore: true,
      showMoreLimit: 100,
    });

    const typeWidget = refinementList({
      container: '#style',
      attribute: 'product_type',
      limit: 10,
      showMore: true,
      showMoreLimit: 100,
    });

    const headerSearchBox = searchBox({
      container: '#desktop-search-form',
      queryHook: debouncePromise( (query,search) => search(query), 1000 ),
      cssClasses: {
        root: 'aa-Autocomplete',
        form: 'aa-Form',
        input: 'aa-Input',
        submit: 'aa-SubmitButton',
        submitIcon: 'aa-SubmitIcon',
        reset: 'aa-ClearButton',
        resetIcon: 'aa-ClearIcon'
      },
      templates: {
        submit({ cssClasses }, { html }) {
          return html`<button class="${cssClasses.submit}" type="submit" title="Submit" aria-label="button" data-uw-rm-empty-ctrl=""><svg class="aa-SubmitIcon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"></path></svg></button>`;
        },
        reset({ cssClasses }, { html }) {
          return html`<button class="${cssClasses.reset}" type="reset" title="Clear" aria-label="button" data-uw-rm-empty-ctrl=""><svg class="aa-ClearIcon" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path></svg></button>`;
        }
      }
    });

    // on the /search page, populate the #desktop-search-form with the algolia InstantSearch searchbar
    // otherwise, algolia is configured to populate the #desktop-search-form with the Autocomplete searchbar
    if (document.querySelector('body').classList.contains('search')) {
      return [vendorWidget, typeWidget, headerSearchBox];
    }
    else {
      return [vendorWidget, typeWidget];
    }
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h3 class="ais-h2">${algoliaShopify.translations.searchTitle}</h3>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}

          <div
            class="ais-facet-dropdown-wrapper ais-facet-conjunctive ais-facet-vendor manual-display"
          >
            <label
              for="vendor"
              class="ais-range-slider--header ais-facet--header ais-header"
              >Brand</label
            >
            <input
              class="ais-dropdown-checkbox"
              type="checkbox"
              id="vendor"
              name="dropdown"
            />
            <div
              class="ais-facet-vendor-container ais-facet-dropdown-container override"
            >
              <div class="ais-Panel">
                <div class="ais-Panel-body">
                  <div id="brand"></div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="ais-facet-dropdown-wrapper ais-facet-conjunctive ais-facet-product_type manual-display"
          >
            <label
              for="product_type"
              class="ais-range-slider--header ais-facet--header ais-header"
              >Style</label
            >
            <input
              class="ais-dropdown-checkbox"
              type="checkbox"
              id="product_type"
              name="dropdown"
            />
            <div
              class="ais-facet-product_type-container ais-facet-dropdown-container override"
            >
              <div class="ais-Panel">
                <div class="ais-Panel-body">
                  <div id="style"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

    algoliaShopify.hooks.registerHook('beforeInstantSearchFacetLimitNumber', function(limit) {
    // Modify default limit, then return a number
    return 100;
  });

 algoliaShopify.hooks.registerHook(
  'beforeInstantSearchProductTemplate',
  function (_defaultTemplate, hit, html, components) {

    // Canonical PDP: /products/{handle}?variant={id}
    const variantId =
      hit.objectID ||
      hit.variant_id ||
      (hit.variants && hit.variants[0] && (hit.variants[0].id || hit.variants[0].legacyResourceId)) ||
      null;

    const canonicalUrl = `/products/${hit.handle}${variantId ? `?variant=${variantId}` : ''}`;

    const {
      product_badge_label,
      product_badge_background = '#3B3B3B',
      product_badge_text_color = '#FFFFFF',
    } = hit?.meta?.custom || {};

    hit.image = hit.product_image || hit.image;

    return html`
      <div
        class="ais-hit ais-product"
        data-test-canonical="1"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${variantId || ''}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        data-canonical-url="${canonicalUrl}"
      >
        ${product_badge_label &&
        html`
          <div class="ais-hit--badge" style="background-color:${product_badge_background};color:${product_badge_text_color}">
            ${product_badge_label}
          </div>
        `}

        <a class="ais-hit--picture-link" href="${canonicalUrl}" aria-label="${hit.title}">
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.mediumImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
          />
        </a>

        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${canonicalUrl}"
              title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct)}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
            </a>
          </p>

          <p class="ais-hit--subtitle" title="${hit.product_type}${algoliaShopify.translation_helpers.by(hit.vendor)}">
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor && html`<span> ${algoliaShopify.translations.by} </span>`}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>

          <p class="ais-hit--price">
            <b class="${hit.compare_at_price && hit.compare_at_price > 0 ? 'sale-price' : ''}">
              ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
            </b>
            ${!hit._distinct && html`
              <span class="ais-hit--price-striked"><span>
                ${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}
              </span></span>`}
            ${!hit._distinct && html`
              <span class="ais-hit--price-discount">
                ${algoliaShopify.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}
              </span>`}
          </p>
        </div>

        <div class="pwr-category-snippets" style="">
          <div id="snippet-${hit.id}"></div>
        </div>

        <div class="product-item__quick-form theme--dark">
          <button is="toggle-button"
                  aria-controls="product-${ _defaultTemplate.props['data-algolia-queryid'] }-${ _defaultTemplate.props['data-product-id'] }-drawer"
                  aria-expanded="false" class="btn">Quick View</button>
        </div>

        <quick-buy-drawer
          id="product-${ _defaultTemplate.props['data-algolia-queryid'] }-${ _defaultTemplate.props['data-product-id'] }-drawer"
          href="${canonicalUrl}&view=quick-buy-drawer"
          class="drawer drawer--large drawer--quick-buy hidden-phone">
        </quick-buy-drawer>
      </div>
    `;
  }
);


});

document.addEventListener('algolia.instantSearch.onRender', () => {
  let pwrElements = [];

  Array.from(document.getElementsByClassName('pwr-category-snippets')).forEach(el => {
    const pId = el?.closest('.ais-hit.ais-product').dataset?.productId;
    pwrElements.push({
      api_key: 'b52d0ed1-06f2-49f5-8fb7-17b36d624837',
      locale: 'en_US',
      merchant_group_id: '1250828238',
      merchant_id: '2113592113',
      page_id: pId,
      ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
      components: {
        CategorySnippet: `snippet-${pId}`
      }
    })
  });

  pwr('render', pwrElements);
});